import styled from 'styled-components'
import { GreatPrimer } from '~/components/Typography'
import ArrowDown from '~/icons/arrow-down.svg'

export const Label = styled(GreatPrimer)`
  flex: 0 0 100%;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme: { toRem } }) => toRem(15)} 0;
`

export const Content = styled.div`
  ${({ theme: { toRem, color } }) => `
    display: none;
    padding: ${toRem(30)};
    margin: 0 -30px;
    width: calc(100% + 60px);
    background: ${color('accent', 80)}
  `}

  &[open] {
    display: block;
  }
`

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  ${({ theme: { color } }) =>
    `&:before, &:after {
      background: ${color('accent', 80)}
    }
  `}

  ${({ theme: { toRem } }) =>
    `padding: 0 ${toRem(30)} !important;`}

  &:before,
  &:last-of-type:after {
    content: '';
    width: 100%;
    height: 1px;
  }

  h4 {
    margin-bottom: -5px;
  }
`

export const Icon = styled(ArrowDown)`
  position: relative;
  fill: #c0c4ce;

  &[open] {
    ${({ theme: { color } }) =>
      `transform: rotate(180deg); fill: ${color('dark')}`}
  }
`
